/* eslint-disable */
import jQuery from 'jquery';

export default class WatchLiveVideoControls {
    constructor() {
        const defaultConfig = {
            selectors: {
                video         : '.js-RC-watchLiveContent__video',
                videoContent  : '.js-RC-watchLiveContent__videoContent',
                videoControls : '.js-RC-videoControls',
                seek          : '.js-RC-videoControls__seek',
                volumeBar     : '.js-RC-videoControls__volume',
                play          : '.js-RC-videoControls__play',
                mute          : '.js-RC-videoControls__mute',
                maximize      : '.js-RC-videoControls__maximizeButton',
                minimize      : '.js-RC-videoControls__minimizeButton',
            },
            classes: {
                isPlayingTrigger             : 'RC-videoControls--isPlayingTrigger',
                isMutedTrigger               : 'RC-videoControls--isMutedTrigger',
                isHoveredTrigger             : 'RC-videoControls--isHoveredTrigger',
                isHoveredVideoContentTrigger : 'RC-watchLiveContent__videoContent--isHoveredTrigger',
            },
        };
        this.config = jQuery.extend(true, defaultConfig, WatchLiveVideoControls);

        this.video = jQuery(this.config.selectors.video).find('video')[0];
        this.videoContent = jQuery(this.config.selectors.videoContent)[0];
        this.seek = jQuery(this.config.selectors.seek)[0];
        this.volumeBar = jQuery(this.config.selectors.volumeBar)[0];
        this.$play = jQuery(this.config.selectors.play);
        this.$mute = jQuery(this.config.selectors.mute);
        this.$maximize = jQuery(this.config.selectors.maximize);
        this.$minimize = jQuery(this.config.selectors.minimize);
        this.$videoContent = jQuery(this.config.selectors.videoContent);
        this.$videoControls = jQuery(this.config.selectors.videoControls);

        this.onVideoPlay = this.onVideoPlay.bind(this);
        this.onVideoPause = this.onVideoPause.bind(this);
        this.onVideoTimeUpdate = this.onVideoTimeUpdate.bind(this);
        this.onVolumeChange = this.onVolumeChange.bind(this);
        this.onRewindVideo = this.onRewindVideo.bind(this);
        this.onRewindingStart = this.onRewindingStart.bind(this);
        this.onRewindingEnd = this.onRewindingEnd.bind(this);
        this.playHandler = this.playHandler.bind(this);
        this.muteHandler = this.muteHandler.bind(this);
        this.maximizeHandler = this.maximizeHandler.bind(this);
        this.minimizeHandler = this.minimizeHandler.bind(this);

        this.mouseEnterVideoContentHandler = this.mouseEnterVideoContentHandler.bind(this);
        this.mouseLeaveVideoContentHandler = this.mouseLeaveVideoContentHandler.bind(this);
        this.mouseMoveVideoContentHandler = this.mouseMoveVideoContentHandler.bind(this);

        this.mouseEnterVideoControlsHandler = this.mouseEnterVideoControlsHandler.bind(this);
        this.mouseLeaveVideoControlsHandler = this.mouseLeaveVideoControlsHandler.bind(this);

        this.hideControls = this.hideControls.bind(this);

        this.videoControlsHovered = false;

        this.listenChanges();
        this.initVolume();
        this.initPlay();
    }

    listenChanges() {
        const rewindEvent = this.getBrowser() === 'IE' ? 'change' : 'input';

        this.video.addEventListener('playing', this.onVideoPlay);
        this.video.addEventListener('pause', this.onVideoPause);
        this.video.addEventListener('timeupdate', this.onVideoTimeUpdate);

        this.volumeBar.addEventListener(rewindEvent, this.onVolumeChange);

        this.seek.addEventListener(rewindEvent, this.onRewindVideo);
        this.seek.addEventListener('mousedown', this.onRewindingStart);
        this.seek.addEventListener('mouseup', this.onRewindingEnd);

        this.$play.on('click', this.playHandler);
        this.$mute.on('click', this.muteHandler);
        this.$maximize.on('click', this.maximizeHandler);
        this.$minimize.on('click', this.minimizeHandler);

        this.$videoContent.on('mouseenter', this.mouseEnterVideoContentHandler);
        this.$videoContent.on('mouseleave', this.mouseLeaveVideoContentHandler);
        this.$videoContent.on('mousemove', this.mouseMoveVideoContentHandler);

        this.$videoControls.on('mouseenter', this.mouseEnterVideoControlsHandler);
        this.$videoControls.on('mouseleave', this.mouseLeaveVideoControlsHandler);
    }

    destroy() {
        const rewindEvent = this.getBrowser() === 'IE' ? 'change' : 'input';

        this.video.removeEventListener('playing', this.onVideoPlay);
        this.video.removeEventListener('pause', this.onVideoPause);
        this.video.removeEventListener('timeupdate', this.onVideoTimeUpdate);

        this.volumeBar.removeEventListener(rewindEvent, this.onVolumeChange);

        this.seek.removeEventListener(rewindEvent, this.onRewindVideo);
        this.seek.removeEventListener('mousedown', this.onRewindingStart);
        this.seek.removeEventListener('mouseup', this.onRewindingEnd);

        this.$play.off('click', this.playHandler);
        this.$mute.off('click', this.muteHandler);
        this.$maximize.off('click', this.maximizeHandler);
        this.$minimize.off('click', this.minimizeHandler);

        this.$videoContent.off('mouseenter', this.mouseEnterVideoContentHandler);
        this.$videoContent.off('mouseleave', this.mouseLeaveVideoContentHandler);
        this.$videoContent.off('mousemove', this.mouseMoveVideoContentHandler);

        this.$videoControls.off('mouseenter', this.mouseEnterVideoControlsHandler);
        this.$videoControls.off('mouseleave', this.mouseLeaveVideoControlsHandler);

        WatchLiveVideoControls.exitFullScreen();
    }

    initVolume() {
        const volume = this.getLocalStorage('replay-volume') || 0.5; // from results
        this.video.volume = volume;
        this.volumeBar.value = volume;

        const isMuted = !!this.getLocalStorage('replay-muted'); // from results
        this.video.muted = isMuted;
        if (isMuted) {
            this.$mute.addClass(this.config.classes.isMutedTrigger);
        } else {
            this.$mute.removeClass(this.config.classes.isMutedTrigger);
        }
    }

    initPlay() {
        if (this.video.paused) {
            this.$play.addClass(this.config.classes.isPlayingTrigger);
        } else {
            this.$play.removeClass(this.config.classes.isPlayingTrigger);
        }
    }

    getBrowser() {
        if (typeof window !== 'object' ||
            !window.navigator ||
            !window.navigator.userAgent) {
            return '';
        }

        const userAgent = window.navigator.userAgent;
        if (userAgent.match(/trident|msie/i)) {
            return 'IE';
        }
        if (userAgent.includes('Edge')) {
            return 'Edge';
        }
        if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) {
            return 'Safari';
        }
        if (userAgent.includes('Chrome')) {
            return 'Chrome';
        }
        if (userAgent.includes('Firefox')) {
            return 'Firefox';
        }
        return '';
    };

    getLocalStorage(key) {
        return JSON.parse(window.localStorage.getItem(key));
    }

    setLocalStorage(key, obj) {
        window.localStorage.setItem(key, JSON.stringify(obj));
    }

    onVideoPlay() {
        this.$play.addClass(this.config.classes.isPlayingTrigger);
    }

    onVideoPause() {
        this.$play.removeClass(this.config.classes.isPlayingTrigger);
    }

    onVideoTimeUpdate() {
        this.seek.value = (100 / this.video.duration) * this.video.currentTime;
    }

    onVolumeChange() {
        this.video.volume = this.volumeBar.value;
        this.setLocalStorage('replay-volume', this.volumeBar.value);
    }

    onRewindVideo() {
        this.video.currentTime = this.video.duration * (this.seek.value / 100);
    }

    onRewindingStart() {
        this.video.pause();
    }

    onRewindingEnd() {
        this.video.play();
    }

    playHandler() {
        if (this.video.paused) {
            this.video.play();
        } else {
            this.video.pause();
        }
    }

    muteHandler() {
        const isMuted = !this.video.muted;
        this.video.muted = isMuted;
        this.setLocalStorage('replay-muted', isMuted);
        if (isMuted) {
            this.$mute.addClass(this.config.classes.isMutedTrigger);
        } else {
            this.$mute.removeClass(this.config.classes.isMutedTrigger);
        }
    }

    maximizeHandler() {
        WatchLiveVideoControls.enterFullScreen(this.videoContent);
    }

    minimizeHandler() {
        WatchLiveVideoControls.exitFullScreen();
    }

    static enterFullScreen(video) {
        if (video.requestFullscreen) {
            video.requestFullscreen();
            return;
        }
        if (video.mozRequestFullScreen) {
            video.mozRequestFullScreen();
            return;
        }
        if (video.webkitRequestFullscreen) {
            video.webkitRequestFullscreen();
            return;
        }
        if (video.msRequestFullscreen) {
            video.msRequestFullscreen();
            return;
        }
    }

    static exitFullScreen() {
        // There are different full screen API in browsers and versions
        if (document.cancelFullScreen) {
            document.cancelFullScreen();
            return;
        }
        if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
            return;
        }
        if (document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen();
            return;
        }
        if (document.webkitExitFullScreen) {
            document.webkitExitFullScreen();
            return;
        }
        if (document.msExitFullscreen) {
            document.msExitFullscreen();
            return;
        }
    }

    mouseEnterVideoContentHandler() {
        // console.log('enter');
        this.showControls();
        this.startTimerHideControls();
    }

    mouseLeaveVideoContentHandler() {
        // console.log('leave');
        this.hideControls();
        this.stopTimerHideControls();
    }

    mouseMoveVideoContentHandler() {
        // console.log('move');
        this.showControls();
        this.startTimerHideControls();
    }

    startTimerHideControls() {
        this.stopTimerHideControls();
        this.hideTimer = setTimeout(this.hideControls, 3000);
    }

    stopTimerHideControls() {
        clearTimeout(this.hideTimer);
        this.hideTimer = null;
    }

    showControls() {
        this.$videoControls.addClass(this.config.classes.isHoveredTrigger);
        this.$videoContent.addClass(this.config.classes.isHoveredVideoContentTrigger);
    }

    hideControls() {
        if (!this.video.paused && !this.videoControlsHovered) {
            this.$videoControls.removeClass(this.config.classes.isHoveredTrigger);
            this.$videoContent.removeClass(this.config.classes.isHoveredVideoContentTrigger);
        }
    }

    mouseEnterVideoControlsHandler() {
        // console.log('controls enter');
        this.videoControlsHovered = true;
    }

    mouseLeaveVideoControlsHandler() {
        // console.log('controls leave');
        this.videoControlsHovered = false;
    }
}



// WEBPACK FOOTER //
// ./lib/js/modules/watchLiveVideoControls.js